import { type ReactNode } from 'react';

export interface CtaBandProps {
    title: string;
    lead: string;
    actions: ReactNode;
}

/** Bottom CTA band: heading, lead paragraph, action buttons centred. */
export function CtaBand({ title, lead, actions }: CtaBandProps) {
    return (
        <section className="mktg-cta">
            <div className="mktg-container mktg-cta__inner">
                <h2 className="mktg-cta__title">{title}</h2>
                <p className="mktg-cta__lead">{lead}</p>
                <div className="mktg-cta__actions">{actions}</div>
            </div>
        </section>
    );
}
